export default __webpack_public_path__ + "static/media/rebated_bg.3984d641.jpg";